<script>
/**
 * A public hazard's type icon, in the colour of the text around it.
 * One component so every hazard list and pill draws the same glyph
 * (lib/hazardIcon.js).
 *
 * LOADED ON DEMAND. A hazard's icon can be any glyph in the product's
 * library — the task type's own pick, or its built-in picture — so
 * drawing one needs the whole registry: about 48 kB compressed, most
 * of it the task-type artwork. Imported statically, that sat in front
 * of every public website page, hazard or none, as the largest script
 * on it.
 *
 * So the glyph is its own chunk (HazardIconGlyph.vue). A page with no
 * hazard never asks for it. A server-rendered page already has the
 * icons in its HTML, and Vue hydrates this part only once it scrolls
 * near the screen — the picture is there from the first paint and the
 * registry downloads behind it. Rendered without the server, an icon
 * appears a moment after its row.
 *
 * The box is styled HERE, not in the glyph, so the space an icon takes
 * is right before the glyph's chunk arrives.
 */
import { defineAsyncComponent, hydrateOnVisible } from 'vue';

export default defineAsyncComponent({
    loader: () => import('./HazardIconGlyph.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '200px' }),
});
</script>

<style>
.tiq-hazard-icon { display: inline-flex; flex: none; line-height: 0; color: currentColor; vertical-align: -0.2em; }
.tiq-hazard-icon svg { width: 100%; height: 100%; display: block; }
</style>
